import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'reactstrap';

function AccountLayout({ children }) {
  const { t } = useTranslation('common');
  return (
    <div>
      <Container className="vl-account-pages">
        <Row className="mt-5">
          <Col>
            <div className="d-flex text-left app-logo-title align-items-center">
              <img
                src="https://assets.hbsuk.co.uk/img/platform/HBSUK_Logo_Colour_RGB.svg"
                alt={t('HBS UK logo')}
                style={{ height: '60px', marginRight: '10px' }}
              />
            </div>
            <hr className="account-hr-login" />
          </Col>
        </Row>
        {children}
        <br />
        <br />
        <br />
      </Container>
    </div>
  );
}

export default AccountLayout;
